import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../../App";

export const levelTone = (l) => (l === null || l === undefined ? "gray" : l <= 3 ? "rose" : l <= 6 ? "amber" : "emerald");
export const LEVEL_HEX = { gray: "#9ca3af", rose: "#e11d48", amber: "#d97706", emerald: "#059669" };
export const LEVEL_BG = { gray: "bg-muted text-muted-foreground", rose: "bg-rose-100 text-rose-700", amber: "bg-amber-100 text-amber-700", emerald: "bg-emerald-100 text-emerald-700" };

export const fmtDate = (d) => (d && d.length >= 10 ? `${d.slice(8, 10)}/${d.slice(5, 7)}/${d.slice(0, 4)}` : d || "");
export const fmtDateTime = (d) => (d ? `${fmtDate(d)} ${d.slice(11, 16)}` : "");

export const downloadPdf = async (url, filename) => {
  try {
    const r = await axios.get(url, { withCredentials: true, responseType: "blob" });
    const href = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
    const a = document.createElement("a"); a.href = href; a.download = filename; a.click();
    setTimeout(() => URL.revokeObjectURL(href), 2000);
  } catch (e) {
    let msg = "Erreur lors de l'export PDF";
    try { msg = JSON.parse(await e.response?.data?.text())?.detail || msg; } catch { /* ignore */ }
    toast.error(msg);
  }
};

export const runClinicalJob = async (patientId, url, body) => {
  const start = await axios.post(url, body, { withCredentials: true });
  const jobId = start.data.job_id;
  for (let i = 0; i < 200; i++) {
    await new Promise((r) => setTimeout(r, 3000));
    const j = await axios.get(`${API}/patients/${patientId}/clinical/jobs/${jobId}`, { withCredentials: true });
    if (j.data.status === "completed") return j.data.result;
    if (j.data.status === "error") throw new Error(j.data.error || "Erreur de génération IA");
  }
  throw new Error("La génération prend trop de temps, réessayez.");
};

export const useClinicalResource = (patientId, path) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const load = () => axios.get(`${API}/patients/${patientId}/clinical/${path}`, { withCredentials: true }).then((r) => setData(r.data)).catch((e) => setError(e.response?.data?.detail || "Erreur de chargement"));
  useEffect(() => { load(); }, [patientId]); // eslint-disable-line react-hooks/exhaustive-deps
  return [data, setData, error, load];
};

export const TestBanner = () => (
  <div className="rounded-xl border border-amber-300 bg-amber-50/70 dark:bg-amber-950/20 p-4 flex items-start gap-3" data-testid="act-test-banner">
    <span className="text-amber-600 text-lg leading-none">⚠</span>
    <div><p className="text-sm font-semibold text-amber-800 dark:text-amber-300">EN TEST</p><p className="text-sm text-amber-800/80 dark:text-amber-200/80">Cette analyse est encore en phase de test — le résultat peut être imparfait. Dites-nous ce qu'il faut améliorer.</p></div>
  </div>
);

export const ReasoningBox = ({ text, hidden, testId }) => (!text || hidden ? null : (
  <div className="rounded-lg bg-muted/50 border border-dashed px-3 py-2" data-testid={testId}>
    <p className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground mb-0.5">Raisonnement de l'IA</p>
    <p className="text-sm italic text-muted-foreground whitespace-pre-line">{text}</p>
  </div>
));
